const accordions = document.querySelectorAll(".ft-Accordion");

accordions.forEach((accordion) => {
    accordion.addEventListener("click", function () {
        const panel = accordion.querySelector('.ft-Accordion_Body');
        accordion.classList.toggle("ft-Accordion-active");

        if (accordion.classList.contains("ft-Accordion-active")) {
            panel.style.maxHeight = panel.scrollHeight + "px";
        } else {
            panel.style.maxHeight = null;
        }

        accordions.forEach((acc) => {
            if (acc !== accordion) {
                acc.classList.remove("ft-Accordion-active");
                acc.querySelector('.ft-Accordion_Body').style.maxHeight = null;
            }
        });
    });
});
